<template>
    <CModal
        class="image-cropping-modal"
        :hide-closer="true"
        title="Orezať obrázok"
        :model-value="true"
        @update:model-value="handleClose"
    >
        <CImageCropper
            class="my-5 block"
            :image="image"
            :size="size"
            :stencil-props="stencilProps"
            @crop="setCroppedImage"
        />

        <template #footer>
            <div class="flex justify-end gap-2">
                <CButton size="large" @click="handleClose"> Zrušiť </CButton>
                <CButton size="large" variant="primary" @click="handleSubmit"> Použiť obrázok </CButton>
            </div>
        </template>
    </CModal>
</template>

<script setup lang="ts">
import { ref } from 'vue'

defineProps({
    image: {
        type: String,
        required: true
    },
    size: {
        type: Number,
        default: 500
    },
    stencilProps: {
        type: Object,
        default: () => ({ aspectRatio: 1 })
    }
})

const emit = defineEmits(['close'])

const croppedImage = ref<string | null>(null)

const setCroppedImage = (image: string) => {
    console.log('Setting cropped image:', image)
    croppedImage.value = image
}

const handleClose = () => {
    console.log('Modal closing without image')
    emit('close', null)
}

const handleSubmit = () => {
    console.log('Modal submitting with image:', croppedImage.value)
    emit('close', croppedImage.value)
}
</script>
